import styled, {css} from 'styled-components';

import {getColor, getRem, ms, square} from '../../../../styles';
import {Image} from '../../../../uikit/Image';
import {Text} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {platform} from '../../../../utils/platform';

export const Container = styled(View)`
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const AvatarImage = styled(Image)<{fadeOut?: boolean}>`
  ${square(platform.isWeb ? 40 : 36)};
  border-radius: ${ms(20)};
  flex-shrink: 0;
  margin-inline-end: ${ms(12)};

  ${p =>
    p.fadeOut &&
    css`
      opacity: 0.5;
    `}
`;

export const Content = styled(View)`
  flex-direction: column;
  flex-shrink: 1;
  min-width: 0;
`;

export const TitleContainer = styled(View)`
  align-items: center;
`;

export const Title = styled(Text).attrs({
  nativeProps: {numberOfLines: 1},
  weight: 'semibold',
})`
  ${() =>
    platform.isNative &&
    css`
      flex-grow: 1;
      flex-shrink: 1;
    `};

  ${() =>
    platform.isWeb &&
    css`
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    `};
`;

export const Subtitle = styled(Text)`
  font-size: ${getRem(12)};
  color: ${getColor('text3')};
`;
